import React, { useContext, useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { Button } from '@jutro/legacy/components';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { screenReaderAnnounce, focusNextElement } from 'premier-capability-hooks';
import messages from './ViolationCatSearchComponent.messages';

import styles from './ViolationCatSearchComponent.module.scss';
import metadata from './ViolationCatSearchComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';



function ViolationCatSearchComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated,index, viewModelService, setSubmission } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ViolationCatSearchComponent');
    const modelVM = _.get(submissionVM, pathUpdated);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();

    const { LoadSaveService } = useDependencies('LoadSaveService');

    const [violationCodeSearchVisible, setViolationCodeSearchVisible] = useState(false);
    const [violationCategory, updateViolationCategory] = useState('');
    const [violationDescription, updateViolationDescription] = useState('');
    const [violationType, updateViolationType] = useState('');
    const [violationPoints, updateViolationPoints] = useState('');
    const vioCatFiePath = `${pathUpdated}.vioCatFie.value`;
    const vioDesFiePath = `${pathUpdated}.desFie.value`;
    const vioTypFiePath = `${pathUpdated}.typFie.value`;
    const vioPointsFiePath = `${pathUpdated}.poiFie.value`;


    const onCell = (item, index, { id: property }) => {
        return item[property];
    };

    const renderSelectButton = (item, index, { id: property }) => (
            <Button type='text' aria-label ={translator(messages.selectVioCategory, {vioDesc: item.description})} onClick={(e) => onActionClick(item)}>
                {translator(messages.select)}
            </Button>
        );

    const loadData = ({ pageSize, page }) => {
        const paginationParams = {
            fromPage: page,
            pageSize: pageSize
        };

        return searchViolationCode(paginationParams);
    };

    const searchViolationCode = async(paginationParams) => {
       
        if(!paginationParams) {
            paginationParams = {
                fromPage: 0,
                pageSize: 10
            };
        }

        const recMarViolationCodeDTO = {
            violationCategory: violationCategory,
            description: violationDescription,
            type: violationType
        };

        const reqParam = {
            recMarViolationCodeDTO: recMarViolationCodeDTO,
            pageNumber: paginationParams.fromPage,
            pageSize: paginationParams.pageSize
        }
        
        const response = await LoadSaveService.getRecMarViolationClassCodes_Ext(reqParam, authHeader);
        setViolationCodeSearchVisible(true);

        if(response != null){
        
            screenReaderAnnounce(`${response.maxNumberOfResults  }Search results are displayed`);

            return {
                rows: response.violationCodes,
                numberOfRows: response.maxNumberOfResults
            };
    } else {
            return {
                rows: [],
                numberOfRows: 0
            };
        }
    };

    const clearSearchTexts = () => {
        updateViolationCategory('');
        updateViolationDescription('');
        updateViolationType('');
        updateViolationPoints('');
    }

    const cancelSearch = () => {
        setViolationCodeSearchVisible(false);
        focusNextElement(true,0, 'violationSearchIconBtn');
    }

    const openSearchPanel = () => {
        setViolationCodeSearchVisible(true);
        focusNextElement(true,1);
    } 

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onActionClick = (object, index) => {
        _.set(submissionVM, vioCatFiePath, object.violationCategory); 
        _.set(submissionVM, vioDesFiePath, object.description); 
        _.set(submissionVM, vioTypFiePath, object.type); 
        _.set(submissionVM, vioPointsFiePath, object.points); 
        setViolationCodeSearchVisible(false);
        setSubmission(submissionVM)
        screenReaderAnnounce(translator(messages.selectedVioCategory, {vioDesc: object.description}));
        focusNextElement(true,0, 'violationSearchIconBtn');
    };

    const clearViolationCategory = () => {
        _.set(submissionVM, vioCatFiePath, '');
        updateWizardData(submissionVM);
    }

      // Close search panel on ESC key
    useEffect(() => {
       
        const handleEsc = (e) => {
            if (e.key === 'Escape') {
                setViolationCodeSearchVisible(false);
            }
        };
       
        window.addEventListener('keydown', handleEsc);
       
        return () => window.removeEventListener('keydown', handleEsc);
    }, [violationCodeSearchVisible]);


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        violationCodeSearchBtn: {
            onClick: () => { searchViolationCode(); },
            visible: false
        },
        violationAdapters: {
            visible: violationCodeSearchVisible,
            key: violationCategory,
            onFetchData: loadData
        },
        violationSearchContainer: {
            visible: violationCodeSearchVisible
        },
        violationAllContainer: {
            visible: violationCodeSearchVisible
        },
        violationCodeResetBtn: {
            onClick: () => { clearSearchTexts(); }
        },
        violationCodeCancelBtn: {
            onClick: () => {cancelSearch(); }
        }, 
        violationSearchIconBtn: {
            onClick: () => {openSearchPanel(); }
        },
        violationCategorySearchInput : {
            value: violationCategory,
            onValueChange: updateViolationCategory
        },
        violationDescriptionSearchInput : {
            value: violationDescription,
            onValueChange: updateViolationDescription
        },
        violationTypeSearchInput : {
            value: violationType,
            onValueChange: updateViolationType
        },
        searchResultHeader: {
            visible: violationCodeSearchVisible
        },
        violationCategoryClearIconBtn: {
            onClick: () => { clearViolationCategory();},
            title: translator(messages.clearCategory)
        },
        
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            onActionClick,
            onCell,
            renderSelectButton
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback((id, path) =>
         readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ViolationCatSearchComponent.propTypes = wizardProps;
export default withRouter(ViolationCatSearchComponent);
